import { createAction, props } from '@ngrx/store';
import { Upload } from '@app/upload/models/upload.model';

export const uploadFile = createAction(
  '[Uploads] upload',
  props<{ upload: Upload }>()
);
